/** @format */

import routeDescriptions from './routeDescriptions';
import Login from '../pages/Login';
import ForgetPassword from '../pages/ForgetPassword';
import Register from '../pages/Register';
import Welcome from '../pages/Welcome';
import Chat from '../pages/Chat';
import Setting from '../pages/Setting';
import User from '../pages/User';
import GroupChatDetail from '../pages/GroupChatDetail';
import AddGroupMember from '../pages/AddGroupMember';
import RemoveGroupMember from '../pages/RemoveGroupMember';
import AddGroupChat from '../pages/AddGroupChat';
import AddContact from '../pages/AddContact';
import ChatList from '../pages/ChatList';
import ContactList from '../pages/ContactList';
import FriendList from '../pages/FriendList';
import BasicInfo from '../pages/BasicInfo';
import Me from '../pages/Me';
import Avatar from '../pages/Avatar';
import UpdateCurrentUserDisplayName from '../pages/UpdateCurrentUserDisplayName';
import UpdateCurrentUserEmail from '../pages/UpdateCurrentUserEmail';
import CurrentUserQrcode from '../pages/CurrentUserQrcode';
import GroupChatQrcode from '../pages/GroupChatQrcode';
import UpdateGroupTitle from '../pages/UpdateGroupTitle';
import UpdateCurrentUserGender from '../pages/UpdateCurrentUserGender';
import PrivacyAndSafety from '../pages/PrivacyAndSafety';
import UserSetting from '../pages/UserSetting';
import UpdateContact from '../pages/UpdateContact';
import UpdateUserDescription from '../pages/UpdateUserDescription';
import BlackList from '../pages/BlackList';
import ForwardMessage from '../pages/ForwardMessage';
import Wallet from '../pages/Wallet';
import BuyCoinList from '../pages/BuyCoinList';
import PayDetail from '../pages/PayDetail';
import MyOrderList from '../pages/MyOrderList';
import MyOrderCreate from '../pages/MyOrderCreate';
import PeddingOrderLog from '../pages/PeddingOrderLog';
import PeddingOrderDetail from '../pages/PeddingOrderDetail';
import Exchange from '../pages/Exchange';
import ExchangeDetail from '../pages/ExchangeDetail';
import ExchangeSuccess from '../pages/ExchangeSuccess';
import TakeOrders from '../pages/TakeOrders';
import TakeOrderDetail from '../pages/TakeOrderDetail';
import Transfer from '../pages/Transfer';
import Receive from '../pages/Receive';
import WalletLog from '../pages/WalletLog';
import WalletLogDetail from '../pages/WalletLogDetail';
import MyBill from '../pages/MyBill';
import Verified from '../pages/Verified';
import VerifiedSuccess from '../pages/VerifiedSuccess';
import PhoneBinding from '../pages/PhoneBinding';
import PhoneBindingSuccess from '../pages/PhoneBindingSuccess';
import PayAccountManage from '../pages/PayAccountManage';
import SettingPayMode from '../pages/SettingPayMode';
import SettingPayNumber from '../pages/SettingPayNumber';
import MyComplaint from '../pages/MyComplaint';
import MyComplaintDetail from '../pages/MyComplaintDetail';
import MyComplaintForm from '../pages/MyComplaintForm';
import CreditRating from '../pages/CreditRating';
import TutorialMap from '../pages/TutorialMap';
import UserNotice from '../pages/UserNotice';
import Share from '../pages/Share';
import SettingDomain from '../pages/SettingDomain';

import ORedirect from '../pages/Redirect';

const Redirect = () => {
  return <ORedirect redirectUrl="/"></ORedirect>;
};

const components = {
  Login,
  ForgetPassword,
  Register,
  Welcome,
  Chat,
  Setting,
  User,
  GroupChatDetail,
  AddGroupMember,
  RemoveGroupMember,
  AddGroupChat,
  AddContact,
  ChatList,
  ContactList,
  FriendList,
  BasicInfo,
  Me,
  Avatar,
  UpdateCurrentUserDisplayName,
  UpdateCurrentUserEmail,
  CurrentUserQrcode,
  GroupChatQrcode,
  UpdateGroupTitle,
  UpdateCurrentUserGender,
  UpdateContact,
  PrivacyAndSafety,
  UserSetting,
  UpdateUserDescription,
  BlackList,
  ForwardMessage,
  Wallet,
  BuyCoinList,
  PayDetail,
  MyOrderList,
  MyOrderCreate,
  PeddingOrderLog,
  PeddingOrderDetail,
  Exchange,
  ExchangeDetail,
  ExchangeSuccess,
  TakeOrders,
  TakeOrderDetail,
  Transfer,
  Receive,
  WalletLog,
  WalletLogDetail,
  MyBill,
  Verified,
  VerifiedSuccess,
  PhoneBinding,
  PhoneBindingSuccess,
  PayAccountManage,
  SettingPayMode,
  SettingPayNumber,
  MyComplaint,
  MyComplaintDetail,
  MyComplaintForm,
  CreditRating,
  TutorialMap,
  UserNotice,
  Share,
  SettingDomain,
  Redirect,
};

const routes = routeDescriptions.map(({ key, ...rest }) => {
  return {
    key,
    ...rest,
    Component: components[key],
  };
});

export default routes;
